import React, { useState } from 'react';
import { Button, Typography } from 'antd';
import { clsx } from 'clsx';

import { Colors, FontSize, FontWeight, LineHeight } from '@common/tokens';
import Auth, { AccountInfoType } from 'works/legacy/lib/auth';
import { AutoAnimatedHeight } from 'works/legacy/components/auto-animated-height';
import { Icon, UserAvatar } from '@common/components';
import { AccountAvatar } from '@identity/components';

import { AccountItem } from './_account-item';

const { Text } = Typography;

export const AccountOption = ({
  accounts,
  handleLogout,
  handleSwitchAccount,
}: {
  accounts: AccountInfoType[];
  handleLogout: () => void;
  handleSwitchAccount: (account: AccountInfoType) => void;
}) => {
  const main = accounts[0];
  const membershipId = Auth.membershipId();
  const [open, setOpen] = useState(main.membershipId === membershipId);
  const toggle = () => setOpen((open) => !open);

  const renderedAccounts = accounts.map((account) => {
    const logged = account.membershipId === membershipId;

    return (
      <AccountItem
        key={account.membershipId}
        className={clsx('account-option', logged && 'logged-in')}
        onClick={() => handleSwitchAccount(account)}
      >
        <AccountAvatar account={account} size={32} />
        <>
          <Text className="body-medium-medium entity-name">
            {account.entityName}
          </Text>
          <Text className="body-small-book" type="secondary">
            {account.membershipRole}
          </Text>
        </>
        {logged && (
          <Button
            id="logout-button"
            icon={<Icon icon="rightFromBracket" kind="light" size="md" />}
            onClick={(e) => {
              e.stopPropagation();
              handleLogout();
            }}
          />
        )}
      </AccountItem>
    );
  });

  return (
    <div className="account-option">
      <AccountItem onClick={toggle}>
        <UserAvatar
          size={32}
          backgroundColor={Colors.elmDarkest}
          textAsInitials={main.name}
        />
        <>
          <Text className="body-medium-medium entity-name sentry-mask">
            {main.name}
          </Text>
          <Text type="secondary" className="body-small-book sentry-mask">
            {main.email}
          </Text>
        </>
        <Icon
          icon="chevronDown"
          kind="light"
          size="md"
          className={clsx('toggle', open && 'open')}
        />
      </AccountItem>
      <AutoAnimatedHeight visible={open} alwaysRendered>
        {renderedAccounts}
      </AutoAnimatedHeight>
      <style jsx>{`
        .account-option :global(.body-small-book) {
          font-size: ${FontSize.xs};
          line-height: ${LineHeight.xs};
          font-weight: 400;
        }
        .account-option :global(.body-medium-medium) {
          line-height: ${LineHeight.sm};
          font-weight: ${FontWeight.medium};
        }
        .account-option :global(.logged-in) {
          background-color: ${Colors.elmHyperlight};
        }
        .account-option :global(.account-item:hover) {
          background-color: ${Colors.elmLightest};
        }
        .account-option :global(.account-item:hover .entity-name) {
          color: ${Colors.elm};
        }
        .account-option :global(.account-item .toggle) {
          transition: transform 0.3s;
        }
        .account-option :global(.account-item .toggle.open) {
          transform: scaleY(-1);
        }
      `}</style>
    </div>
  );
};
